/*
|--------------------------------------------------------------------------
| Data: Validate: Item
|--------------------------------------------------------------------------
*/
/**
 * @namespace
 */
__gh__webApp.data.validate.item = {

	/**
	 * Check to see if story has an image
	 * @param  {object} data - story object
	 * @return {boolean}     - returns true or false
	 */
	"hasImage": function(item){
		if("image" in item && !__gh__webApp.common.isObjectEmpty(item.image)) {return true;}
		return false;
	},
	"hasRelatedContent": function(item){
		if("relatedContent" in item && !__gh__webApp.common.isObjectEmpty(item.relatedContent)) {return true;}
		return false;
	},
	"hasRelatedContentContent": function(item){
		if(this.hasRelatedContent(item) 			&&
		 	"relatedContent" in item 				&&
		 	"content" in item.relatedContent 		&&
		 	"items" in item.relatedContent.content 	&&
		 	!__gh__webApp.common.isObjectEmpty(item.relatedContent.content.items)
		  ) {return true;}
		return false;
	},
	"isGallery": function(item){
		if(item.type=="gallery"){return true;}
		return false;
	},
	"isOpinion": function(item){
		if((item.taxonomy && item.taxonomy.indexOf("Opinion") >= 0) || (item.category && item.category.toLowerCase() == "opinion")){
			return true;
		}
		return false;
	},
	"isStory": function(item){
		if(item.type=="story"){return true;}
		return false;
	},
	"isVideo": function(item){
		if(item.type=="video"){return true;}
		return false;
	}
};
